module.exports = __webpack_public_path__ + "img/album.da341a0a.jpeg";